module.exports = __webpack_public_path__ + "img/undershy.80f15950.png";